<div class="card">
  <div class="card-content">
    <div class="page-header">
      <h4 translationEditableDirective="CREATE_INDUSTRY">
        {{ 'CREATE_INDUSTRY' | translate }}
      </h4>
    </div>

    <form class="form" (submit)="onSubmit($event)">
      <div class="field is-narrow">
        <label class="label" translationEditableDirective="Name">{{
          'NAME' | translate
        }}</label>
        <div class="control">
          <input
            class="input"
            name="name"
            type="text"
            (input)="handleFieldChange($event)"
            [value]="getField(['name'])"
            [ngClass]="{ 'is-danger': hasError('name') }"
          />
        </div>
        <p class="help is-danger" *ngIf="hasError('name')">
          {{ getError('name') }}
        </p>
      </div>

      <div class="field is-narrow">
        <label
          class="label"
          translationEditableDirective="PENALTY_PERCENTAGE"
          >{{ 'PENALTY_PERCENTAGE' | translate }}</label
        >
        <div class="control">
          <number-input
            name="penaltyPercentage"
            step="1"
            (input)="handleFieldChange($event)"
            [value]="getField(['penaltyPercentage'])"
            [inputClass]="{
              input: true,
              'is-danger': hasError('penaltyPercentage')
            }"
          />
        </div>
        <p class="help is-danger" *ngIf="hasError('penaltyPercentage')">
          {{ getError('penaltyPercentage') }}
        </p>
      </div>

      <div class="field is-narrow">
        <label class="label">{{ 'MILL_RATE' | translate }}</label>
        <div class="control">
          <number-input
            name="millRate"
            step="1"
            (input)="handleFieldChange($event)"
            [value]="getField(['millRate'])"
            [ngClass]="{ input: true, 'is-danger': hasError('millRate') }"
          />
        </div>
        <p class="help is-danger" *ngIf="hasError('millRate')">
          {{ getError('millRate') }}
        </p>
      </div>

      <div class="field is-narrow">
        <label class="label" translationEditableDirective="MINIMUM_TAX">{{
          'MINIMUM_TAX' | translate
        }}</label>
        <div class="control">
          <number-input
            name="minTax"
            step="1"
            (input)="handleFieldChange($event)"
            [value]="getField(['minTax'])"
            [inputClass]="{ input: true, 'is-danger': hasError('minTax') }"
          />
        </div>
        <p class="help is-danger" *ngIf="hasError('minTax')">
          {{ getError('minTax') }}
        </p>
      </div>

      <sub-industries
        (rowAdd)="rowAdd()"
        (rowDelete)="rowDelete($event)"
        [data]="state.getIn(['data', 'subIndustryList'])"
        (fieldChange)="handleFieldChange($event.e, null, $event.row)"
      >
      </sub-industries>

      <div class="field is-grouped">
        <div class="control">
          <button
            [disabled]="isLoading"
            type="submit"
            class="button is-link"
            translationEditableDirective="SUBMIT"
          >
            {{ 'SUBMIT' | translate }}
          </button>
        </div>
        <div class="control">
          <a
            [routerLink]="['/admin/industries']"
            class="button is-link is-light"
            translationEditableDirective="CANCEL"
            >{{ 'CANCEL' | translate }}</a
          >
        </div>
      </div>
    </form>
  </div>
</div>
